import { ApiResult } from 'types';
import { fetchAuthSession } from 'aws-amplify/auth';
import { API_BASE_URL } from 'utils/constants';

const getAuthHeaders = async (): Promise<Record<string, string>> => {
  let token: string | undefined;

  try {
    const session = await fetchAuthSession();
    token = session.tokens?.idToken?.toString();
  } catch {
    token = undefined;
  }

  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

export const postRequest = async <T = ApiResult>(
  endpoint: string,
  payload: Record<string, unknown>
): Promise<T | undefined> => {
  const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
    method: 'POST',
    headers: await getAuthHeaders(),
    body: JSON.stringify(payload),
  });

  if (response.status === 401) {
    window.location.href = '/';
    return;
  }

  return response.json();
};

export const getRequest = async (
  endpoint: string
): Promise<ApiResult | undefined> => {
  const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
    method: 'GET',
    headers: await getAuthHeaders(),
  });

  if (response.status === 401) {
    window.location.href = '/';
    return;
  }

  return response.json();
};